import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ONBOARDING_STEPS } from "./OnboardingShell";

/** First-run welcome + checklist. Guides the owner through configuring the clinic. */
export function OnboardingWelcomePage() {
  const navigate = useNavigate();
  return (
    <div className="max-w-2xl font-sans">
      <div className="mb-4">
        <Badge variant="warning">Thiết lập ban đầu</Badge>
        <h1 className="mt-2 text-2xl font-semibold tracking-tight text-foreground">
          Bắt đầu cùng Addy HIS Lite
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Vài bước ngắn để phòng khám sẵn sàng nhận bệnh: thông tin phòng khám,
          dịch vụ, bác sĩ, lịch làm việc và dữ liệu bệnh nhân.
        </p>
      </div>

      <Card>
        <CardContent className="grid gap-3 pt-6">
          <ol className="grid list-decimal gap-1.5 pl-5 text-sm text-foreground">
            {ONBOARDING_STEPS.map((s) => (
              <li key={s.path}>{s.label}</li>
            ))}
          </ol>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <Button asChild variant="link">
              <Link to="/dashboard">Bỏ qua, vào Dashboard</Link>
            </Button>
            <Button type="button" onClick={() => navigate("/onboarding/clinic")}>
              Bắt đầu thiết lập
              <ArrowRight className="h-4 w-4" />
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
